import { OnActionArgs, OnEnterArgs, State } from '..';

type OnEnter<S, P, R, T> = (state: OnEnterArgs<S, P, R>) => Promise<boolean>;
type OnAction<S, P, R, T> = (state: OnActionArgs<S, P, R>) => Promise<boolean>;

interface EventProps {}

interface Config<S, P, A, R, T> {
  nextState: number;
  attributes?: Partial<A>;
  onEnter?: OnEnter<S, P, R, T>;
  onAction?: OnAction<S, P, R, T>;
}

const StateOK = function <S, P extends EventProps, A, R, T>({
  nextState,
  attributes,
  onEnter,
  onAction
}: Config<S, P, A, R, T>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      if (onEnter) {
        const result = await onEnter(args);
        if (result) {
          return {
            type: 'MOVE',
            nextState,
          };
        }
      }
    },

    onAction: async (args) => {
      if (onAction) {
        const result = await onAction(args)
        if (!result) {
          throw new Error("do not proceed")
        }
      }
      return {
        type: 'MOVE',
        data: {} as any,
        nextState,
      };
    },

    attributes: {
      hint: 'T.hints.location',
      ...(attributes as any),
    },

    nodeName: 'T.states.findAny',
    outputs: [
      {
        name: 'onOK',
        to: nextState,
      },
    ],
  };
};

export default StateOK;
